import React , { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import MaterialTable, { MaterialTableProps } from 'material-table';
// import SvgIcon from '@material-ui/core/SvgIcon';
import { SVG_ICONS } from '../../../shared/icons/SvgIcons';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useLocation } from 'react-router-dom';
import { initQueryParams, replaceHistory, tableOptions, useQuery } from '../../../shared/lib/TableQueryParams';
import { PaginatedResponse } from '../../../shared/models';
//  CustomTableTitle, ErrorStatusBar } from '../../../shared/components';
import composeRequest from '../../../shared/api/core';
import { checkStatus, parseJSON, handleError } from '../../../shared/api/core/common';
import { getBusinessListFromAPI } from '../../../shared/data/actions';
import { API_URLS } from '../../api';
import { EMPTY_ROW_MSG, ERROR_500, ERROR_MSG } from '../../../shared/lib/Localization';
import { PriceMissingOrZero } from '../../models';
import { getCgByEBTSectorDiscSummary } from '../../api';

import {
    CustomTableTitle,
    ErrorStatusBar,
    ExportMenu,
    ExportStatusBar,
} from '../../../shared/components';
import download from 'downloadjs';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            padding: theme.spacing(3),
            marginBottom: theme.spacing(2),
        },
        formControl: {
            // margin: theme.spacing(1),
            minWidth: 120,
            width: '100%',
            maxWidth: '16rem'
        },
        progress: {
            margin: theme.spacing(2),
        },
    }),
);

const CgByEBTSectorDiscSummaryScreen = (props: any) => {
    const classes = useStyles({});
    const [emptyDataSourceMessage, setEmptyDataSourceMessage] = useState(EMPTY_ROW_MSG);
    const [isErrorStatusVisible, setErrorStatusVisible] = useState(false);
    const tableRef = useRef<{ onQueryChange: any; }>();
    let locationQuery = useQuery(useLocation);
    const [tableQuery, setTableQuery] = useState(initQueryParams(locationQuery));
    const [exportBtnAnchorEl, setExportBtnAnchorEl] = React.useState<null | HTMLElement>(null);
    const [isExporting, setExporting] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [initialLoad,setInitialLoad]=useState(true);
    const [totalRecords, setTotalRecords] = useState(null as any)
    
    
    useEffect(()=>{
        console.log("totalRecords",totalRecords)
    },[totalRecords])

    useEffect(() => {
        if (!isLoading && !initialLoad) {
            tableRef && tableRef.current && tableRef.current.onQueryChange();
            setTotalRecords(null)
        }
    }, [props.userData.selectedBusiness]);


    const handleRefresh= ()=>{
        setTotalRecords(null)
        tableRef.current && tableRef.current.onQueryChange()
    }

    const exportCSV = () => {
        if (props.userData && props.userData.selectedBusiness) {
            setExporting(true);
            const sb = props.userData.selectedBusiness;
            const shouldExport = true;
            getCgByEBTSectorDiscSummary(
                sb.business_id,
                null,
                null,
                tableQuery.search,
                true ? totalRecords : false,
                sb.orderBy,
                null,
                shouldExport
            )
                .catch(handleError) // handle network issues
                .then(checkStatus)
                .then((res) => res.blob())
                .then((data) => {
                    download(data, 'CG_By_EBT_Sector_Disc_Summary.csv', 'text/csv');
                    setExporting(false);
                })
                .catch((error: any) => {
                    setExporting(false);
                    if (error) {
                        if (error.status && error.status === 500) {
                            setEmptyDataSourceMessage(ERROR_MSG);
                            setErrorStatusVisible(false);
                        } else if (error.status === 403 || error.status === 401) {
                            setEmptyDataSourceMessage(ERROR_MSG);
                            setErrorStatusVisible(true);
                        } else {
                            setEmptyDataSourceMessage(ERROR_MSG);
                            setErrorStatusVisible(false);
                        }
                    }
                });
        }
    };


    const handleExportClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setExportBtnAnchorEl(event.currentTarget);
    };


    const handleExportMenuClose = (shouldExport: boolean) => {
        if (shouldExport) {
            exportCSV();
        }
        setExportBtnAnchorEl(null);
    };


    return (
        <Container maxWidth={false}>
            <ErrorStatusBar isVisible={isErrorStatusVisible} />
            <ExportStatusBar isVisible={isExporting} />

            <div className="table-wrapper">
                <MaterialTable
                    options={{ 
                        ...tableOptions(tableQuery),
                        thirdSortClick: false,
                        draggable: false,
                        sorting: true
                    }}
                    tableRef={tableRef}
                    localization={{
                        body: {
                            emptyDataSourceMessage: emptyDataSourceMessage
                        }
                    }}
                    columns= {[
                        {
                            title: 'CG Parent Name',
                            field: 'CommGrp_Parent_Name',
                            render: rowData => {
                              if (rowData && rowData.CommGrp_Parent_Name) {
                                return (
                                  <div style={{ minWidth: 200 }}>
                                    {rowData.CommGrp_Parent_Name}
                                  </div>
                                )
            
                              }
                              return null
                            },
            
                          },
                          {
                            title: 'CG Name',
                            field: 'CommGrp_Name',
                            render: rowData => {
                              if (rowData && rowData.CommGrp_Name) {
                                return (
                                  <div style={{ minWidth: 200 }}>
                                    {rowData.CommGrp_Name}
                                  </div>
                                )
            
                              }
                              return null
                            },
            
                          },
                          { title: 'Total Items', field: 'TotalItems' },
                          { title: 'EBT Items', field: 'EBTItems' },
                          { title: 'Sec 1 Count', field: 'Sector1Count' },
                          { title: 'Sec 2 Count', field: 'Sector2Count' },
                          { title: 'Discount Yes Count', field: 'DiscountYesCount' },


                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            replaceHistory(query, props.history);
                            let pageData = {
                                data: [] as PriceMissingOrZero[],
                                totalCount: 0,
                                page: query.page
                            };
                            if (props.userData && props.userData.selectedBusiness){
                                const sb = props.userData.selectedBusiness;
                                let orderBy = '';
                                if (query.orderBy) {
                                    orderBy = query.orderBy.field as string;
                                    orderBy = `${query.orderDirection && query.orderDirection === 'desc' ? '-' : ''}${orderBy}`;
                                }
                                let totalRecsAvailable = totalRecords !== null ?  true : false
                                getCgByEBTSectorDiscSummary(
                                    sb.business_id,
                                    query.page + 1,
                                    query.pageSize,
                                    query.search,
                                    totalRecsAvailable,
                                    orderBy,
                                    null,
                                    false
                                )
                                    .catch(handleError) // handle network issues
                                    .then(checkStatus)
                                    .then(parseJSON)
                                    .then((data: PaginatedResponse<PriceMissingOrZero>) => {
                                        setErrorStatusVisible(false);
                                        setEmptyDataSourceMessage(EMPTY_ROW_MSG);
                                        if(!totalRecords){
                                            setTotalRecords(data.count)
                                        }
                                        pageData = {
                                            data: data.results,                                            
                                            totalCount: !totalRecords ? data.count : totalRecords,
                                            page: query.page
                                        };
                                        setTableQuery({
                                            ...tableQuery,
                                            orderBy,
                                            totalCount: !totalRecords ? data.count : totalRecords,
                                            page: query.page,
                                            pageSize: query.pageSize
                                        });
                                        // console.log(pageData.data)
                                        setInitialLoad(false)
                                        resolve(pageData);
                                        // console.log(pageData.data)
                                    })
                                    .catch((error: any) => {
                                        if (error) {
                                            if (error.status && error.status === 500) {
                                                setEmptyDataSourceMessage(ERROR_500);
                                                setErrorStatusVisible(false);
                                            } else if ((error.status === 403 || error.status === 401)
                                            ) {
                                                setEmptyDataSourceMessage(ERROR_MSG);
                                                setErrorStatusVisible(true);
                                            } else {
                                                setEmptyDataSourceMessage(ERROR_MSG);
                                                setErrorStatusVisible(false);
                                            }
                                        }
                                        setTableQuery({
                                            ...tableQuery,
                                            totalCount: 0,  
                                            page: query.page,
                                            pageSize: query.pageSize
                                        });
                                        resolve(pageData);
                                    });
                            }
                        })
                    }
                    title={
                        <CustomTableTitle
                            history={props.history}
                            title={'Cg By EBT Sector Disc Summary'}
                            icon={SVG_ICONS.product} />
                    }
                    actions={[
                        {
                            icon: 'save_alt',
                            tooltip: 'Export',
                            isFreeAction: true,
                            onClick: handleExportClick,
                            disabled: isExporting,
                        },
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => handleRefresh()
                        },
                    ]}
                />
                <ExportMenu anchorEl={exportBtnAnchorEl} handleClose={handleExportMenuClose} />

            </div>
        </Container>
    );
};


const mapStateToProps = (state: any) => {
  return {
      userData: state.userLocalData,
  };
};



const mapDispatchToProps = (dispatch: any) => {
  return {
      getBusinessList: () => dispatch(getBusinessListFromAPI())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CgByEBTSectorDiscSummaryScreen);






    

